import { SVGComponentProps } from "./utils/Types"

const GridIcon = ({ width = 24, height = 24, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill="currentColor"
                d="M13.8157 9.86808H9.86833V13.8154H13.8157V9.86808ZM15.7894 9.86808V13.8154H18.7499V9.86808H15.7894ZM13.8157 18.7496V15.7891H9.86833V18.7496H13.8157ZM15.7894 18.7496H18.7499V15.7891H15.7894V18.7496ZM13.8157 4.93389H9.86833V7.89441H13.8157V4.93389ZM15.7894 4.93389V7.89441H18.7499V4.93389H15.7894ZM7.89465 9.86808H4.93413V13.8154H7.89465V9.86808ZM7.89465 18.7496V15.7891H4.93413V18.7496H7.89465ZM7.89465 4.93389H4.93413V7.89441H7.89465V4.93389ZM3.94729 2.96021H19.7367C20.2818 2.96021 20.7236 3.40203 20.7236 3.94705V19.7365C20.7236 20.2815 20.2818 20.7233 19.7367 20.7233H3.94729C3.40228 20.7233 2.96045 20.2815 2.96045 19.7365V3.94705C2.96045 3.40203 3.40228 2.96021 3.94729 2.96021Z"
            />
        </svg>
    )
}

export default GridIcon
